<head>
    <meta name="viewport" content="width=device-width, initial-scale=1">
  </head>
<template>
  <div class="Evaluation-modal-overlay" @click="close()">
    <div class="Evaluation-modal" @click.stop>
      <h3 style="font-size: 1.5rem; margin-bottom: 10px;">Choose Task for Assessment for Trainee (UID: {{ this.trainee.license_no }})</h3>
      <table class="assessment-table">
        <thead>
          <tr>
            <th style="width: 10%;">Chapter No
              <select v-model="selectedChapter">
                <option value="All">All</option>
                <option v-for="chapter in uniqueChapters" :key="chapter" :value="chapter">{{ chapter }}</option>
              </select>
            </th>
            <th style="width: 8%;">Task No</th>
            <th style="width: 40%;">Description</th>
            <th style="width: 8%;">M/O
              <select v-model="selectedMO">
                <option value="All">All</option>
                <option v-for="mo in uniqueMOs" :key="mo" :value="mo">{{ mo }}</option>
              </select>
            </th>
            <th style="width: 8%;">Scope
              <select v-model="selectedScope">
                <option value="All">All</option>
                <option v-for="scope in uniquescopes" :key="scope" :value="scope">{{ scope }}</option>
              </select>
            </th>
            <th style="width: 15%;">Select
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="task in filteredTasks" :key="task.task_id">
            <td>{{ task.chapt_no }}</td>
            <td>{{ task.task_no }}</td>
            <td>{{ task.description }}</td>
            <td>{{ task.manob }}</td>
            <td>{{ task.scope }}</td>
            <td style="text-align: center;">
              <button v-if="task.is_selected === 1" class="PDF-button" :class="{
                'pass-button': task.assessments && task.assessments.some(assessment => assessment.result === 'pass' && assessment.is_submitted > 2),
                'fail-button': task.assessments && task.assessments.every(assessment => assessment.result === 'fail') && task.assessments[2]?.is_submitted >= 2,
                'in-progress-button': ((task.assessments && task.assessments.some(assessment => assessment.is_submitted === 1)) || (task.assessments && task.assessments.some(assessment => assessment.result && assessment.is_submitted === 2)))
              }" @click="openTaskAttemptModal(task)">
                <template v-if="task.assessments && task.assessments.some(assessment => assessment.result === 'pass') && task.assessments.every(assessment => assessment.is_submitted > 2)">
                  Passed
                </template>
                <template
                  v-else-if="task.assessments && task.assessments.every(assessment => assessment.result === 'fail') && task.assessments[2]?.is_submitted >= 2">
                  Failed
                </template>
                <template
                  v-else-if="(task.assessments && task.assessments.some(assessment => assessment.is_submitted === 1))">
                  In Progress
                </template>
                <template v-else-if="task.assessments && task.assessments.every(assessment => assessment.result) && task.assessments.some(assessment => assessment.is_submitted === 2)">
                  Signature Required
                </template>
                <template
                  v-else-if="(task.is_selected === 1)">
                  Selected
                </template>
                <template v-else>
                  Select
                </template>
              </button>
            </td>
          </tr>
          <tr v-if="filteredTasks.length === 0">
            <td colspan="100" style="text-align: center; font-weight: bold;">
              No matching Assessment Tasks completed by Trainee
            </td>
          </tr>
        </tbody>
      </table>
      <div class="button-container">
        <button class="ins-close-button" @click="close()">Close</button>
      </div>
      <TaskAttemptModal v-if="showTaskAttemptModal" :logbook-id="parseInt(logbookId)" :trainee="trainee" :selectedTaskAssessment="selectedTask" :assessmentMergedTasks="assessmentMergedTasks" @close="closeTaskAttemptModal"></TaskAttemptModal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TaskAttemptModal from './TraineeChooseTaskAttemptModal.vue';

export default {
  props: {
    taskId: {
      type: Number,
      required: true,
    },
    logbookId: {
      type: Number,
      required: true,
    },
    mergedTasks: { // Accept the mergedTasks data from the parent component
      type: Array,
      required: true,
    },
    trainee: {
      type: Object,
      required: true,
    },
  },
  components: {
    TaskAttemptModal,
  },
  data() {
    return {
      completedTrainees: [],
      completedTraineesSecondAttempt: [],
      completedTraineesThirdAttempt: [],
      logbookEntry: {},
      currentTask: {},
      assessmentMergedTasks: [],
      selectedMO: 'All',
      selectedCompleted: 'All tasks',
      selectedScope: 'All',
      selectedChapter: 'All',
      task_assessments: [],
      showTaskAttemptModal: false,
      selectedTask: {},
    };
  },
  computed: {
    filteredTasks() {
      return this.assessmentMergedTasks.filter(task => {
        const moMatches = this.selectedMO === 'All' || task.manob === this.selectedMO;
        //const levelMatches = this.selectedLevel === 'All' || task.level === parseInt(this.selectedLevel);
        const scopeMatches = this.selectedScope === 'All' || task.scope === this.selectedScope;
        const chapterMatches = this.selectedChapter === 'All' || task.chapt_no === this.selectedChapter;

        return moMatches && scopeMatches && chapterMatches;
      });
    },
    uniqueChapters() {
      const chapters = this.assessmentMergedTasks.map(task => task.chapt_no);
      return [...new Set(chapters)]; // This will remove any duplicates and return unique values.
    },
    uniqueMOs() {
      const MOs = this.assessmentMergedTasks.map(task => task.manob);
      return [...new Set(MOs)];
    },
    uniquescopes() {
      const scopes = this.assessmentMergedTasks.map(task => task.scope);
      return [...new Set(scopes)];
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    fetchTaskAssessmentData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = parseInt(this.logbookId);

      axios.get(`/api/task_assessments/logbooks/${logbookId}`, { headers })
        .then(response => {
          this.task_assessments = response.data;
          console.log('assessments', this.task_assessments);

          // Perform the merge after fetching assessments
          this.mergeTaskData();
        });
    },
    mergeTaskData() {
      // Merge `this.assessmentMergedTasks` with `this.task_assessments`
      this.assessmentMergedTasks = this.assessmentMergedTasks.map(task => {
        // Find all assessments for the current task_id
        const matchingAssessments = this.task_assessments.filter(
          assessment => assessment.task_id === task.task_id
        );

        // Return the task enriched with the matching assessments
        return {
          ...task, // Include the original task properties
          assessments: matchingAssessments, // Add a new property with all matching assessments
        };
      });
      console.log('assessmentMerged', this.assessmentMergedTasks);
    },
    async openTaskAttemptModal(task) {
      this.selectedTask = task;
      console.log('task', this.selectedTask);
      this.showTaskAttemptModal = true;
  },
    closeTaskAttemptModal() {
      this.showTaskAttemptModal = false;
      this.fetchTaskAssessmentData();
    },
  },
  mounted() {
    console.log('mergedTasks')
    console.log(this.mergedTasks);
    this.assessmentMergedTasks = this.mergedTasks.filter(task => task.is_exam && task.completed);
    console.log(this.assessmentMergedTasks);
    this.fetchTaskAssessmentData();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-button,
.cancel-button {
  padding: 10px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Evaluation-modal-overlay {
  position: absolute;
  top: 0px;
  left: 0;
  background-color: rgba(97, 94, 94, 0.5);
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 2px;
  max-height: 85vh;
  max-width: 90vw;
  min-width: 80vw;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.assessment-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.signature-section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.signature-item label {
  width: 40%;
  display: block;
  margin-bottom: 5px;
}

.signature-placeholder,
.date-placeholder {
  border: 1px solid #ddd;
  padding: 5px;
  min-height: 30px;
  /* Adjust as needed */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 20px;
  /* Adjust as needed */
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(92, 23, 23);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  min-width: 100px;
  max-width: 120px;
  margin-right: 5%;
  height: 35px;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-clear-button {
  background-color: #f0ac9c;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 0;
  width: 100%;
  min-width: 140px;
  max-width: 150px;
  border: 1px solid #c7715e;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.assessment-result {
  margin-left: 25%;
}

.task-performance {
  width: 50%;
  border-collapse: collapse;
  text-align: left;
  background-color: #f2f2f2;
  margin-left: 20px;
}

.task-performance th {
  /* Adjust the color to match your header background */
  font-weight: bold;
}


.task-performance input[type="text"] {
  width: 100%;
  border: none;
  padding: 4px;
  text-align: center;
  background-color: #f2f2f2;
}

.assessment-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

.signature-table input[type="text"],
.signature-table input[type="date"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0px;
  background-color: transparent;
  outline: none;
  height: 20px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllSatisfactory {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.PDF-button {
  border: 1px solid #555c57;
  border-radius: 2px;
  background-color: #d6d6d6;
}

.PDF-button:hover {
  background-color: rgb(180, 180, 180);
}

.PDF-button:disabled:hover {
  cursor: not-allowed;
}

.pass-button {
  border: 1px solid #507458;
  border-radius: 2px;
  background-color: #b0e6bd;
  color: #075e1a;
}

.pass-button:hover {
  background-color: #82d896;
}

.fail-button {
  border: 1px solid #745050;
  border-radius: 2px;
  background-color: #e6b0b0;
  color: #7a0606;
}

.fail-button:hover {
  background-color: #d88282;
}

.in-progress-button {
  border: 1px solid #a06e36;
  border-radius: 2px;
  background-color: #e4d09c;
  color: #724400;
}

.in-progress-button:hover {
  background-color: #d8b382;
}
</style>